<template>
    <div>        
        <el-alert title="提示" type="warning" show-icon :closable="false">该页面仅用于操作和展示演出主办在秀动之外的售票数据</el-alert>
        <div class="page-btns-box MT20">
            <el-button type="primary" @click="$refs.batchOrderData2.show()" v-if="data && data.activityStatus == 2">导入自有渠道实名制电子票</el-button>
			<el-button type="primary" @click="$refs.setRealnameTicket.show()" v-if="data && data.activityStatus == 2">新建自有渠道实名制电子票</el-button>
        </div>
        <div v-if="data" class="page-list-box">
            <el-table :data="data.thirdTicketList" border style="width: 100%" v-loading="dataLoading" size="small"
                stripe>
                <el-table-column prop="source" label="来源"></el-table-column>
                <el-table-column prop="totalAmount" label="总收入"></el-table-column>
                <el-table-column prop="totalNum" label="总票数"></el-table-column>
            </el-table>
        </div>
        <div class="page-btns-box">
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" plain @click="$refs.batchStaffIcData.show()">导入工作人员</el-button>
            <el-button type="primary" plain @click="$refs.batchStaffCert.show()">导入工作人员身份证池</el-button>
        </div>
        <BatchOrderData2 ref="batchOrderData2" :id="id" :sessionIdNameList="sessionIdNameList" :activity="data" @onUpdate="getData">
        </BatchOrderData2>
        <BatchStaffIcData ref="batchStaffIcData" :id="id" :sessionIdNameList="sessionIdNameList" @onUpdate="getData">
        </BatchStaffIcData>
        <BatchStaffCert ref="batchStaffCert" :id="id" :sessionIdNameList="sessionIdNameList" @onUpdate="getData"></BatchStaffCert>
		<SetRealnameTicket ref="setRealnameTicket" :id="id" :sessionIdNameList="sessionIdNameList" :activity="data" @onUpdate="getData">
		</SetRealnameTicket>
    </div>
</template>

<script>
import BatchOrderData2 from './batchOrderData2';
import BatchStaffIcData from './batchStaffIcData';
import BatchStaffCert from './batchStaffCert'
import SetRealnameTicket from './setRealnameTicket';

export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    components: { BatchOrderData2, BatchStaffIcData, BatchStaffCert ,SetRealnameTicket},
    data() {
        return {
            redirect: this.$route.query.redirect || '/activityManage/activity/list',
            dataLoading: false,
            data: null,
            activityName: '',
            sessionIdNameList: []
        }
    },
    mounted() {
        this.getData();
        this.getSession();
    },
    methods: {
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
        //获取数据
        getData() {
            this.dataLoading = true;
            this.$request({
                url: "/activity/thirdTicket",
                params: { activityId: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                        this.activityName = result.activityName;
                    } else {
                        this.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //场次
        getSession() {
            this.$request({
                url: '/activity/sessionNames',
                params: { activityId: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, result } = res.data;
                    if (state == 1) {
                        this.sessionIdNameList = result || [];
                    }
                })
        },

    }

}
</script>

<style lang="scss" scoped>

</style>